<h1 mat-dialog-title class="no-margin">
  DETTAGLIO PROPOSTA COMPETENZA
  <mat-icon class="close-icon" (click)="onNoClick()">close</mat-icon>
</h1>

<!-- Usa mat-dialog-content per abilitare lo scroll automatico -->
<mat-dialog-content class="dialog-body-overflow">
  <div class="wrapper-content-box">
    <div class="info-box">
      <mat-list role="list">
        <mat-list-item role="listitem">
          <strong class="caption">Stato proposta:</strong>
          <span class="grey noFloat">{{ data.competenza.stato.descrizione }}</span>
        </mat-list-item>
        <mat-list-item role="listitem">
          <strong class="caption">Invio proposta:</strong>
          <span class="grey noFloat">{{ data.competenza.dataInvio | date:'dd/MM/yyyy' }}</span>
        </mat-list-item>
        <mat-list-item role="listitem">
          <strong class="caption">Tipologia:</strong>
          <span class="grey noFloat">{{ data.competenza.tipologia.descrizione }}</span>
        </mat-list-item>

        <div class="toggle-row">
          <div class="toggle-item">
            <p class="text-lg">Digitale</p>
            <label class="switch">
              <input type="checkbox" [(ngModel)]="data.competenza.digital" [name]="'toggleDigital'" (change)="onDigitalToggleChange()">
              <span class="slider round"></span>
            </label>
          </div>

          <div class="toggle-item">
            <p class="text-lg">Green</p>
            <label class="switch">
              <input type="checkbox" [(ngModel)]="data.competenza.green" [name]="'toggleGreen'" (change)="onGreenToggleChange()">
              <span class="slider round"></span>
            </label>
          </div>
        </div>
      </mat-list>
    </div>
  </div>

  <div class="content-box">
    <form class="edit-competenza-form">
      <mat-form-field appearance="fill">
        <mat-label>Nome Competenza</mat-label>
        <input matInput placeholder="Placeholder" name="descrizione" [(ngModel)]="formValues.descrizione">
      </mat-form-field>

      <mat-form-field *ngIf="data.competenza.tipologia.id === 3" class="half-width" appearance="fill">
        <mat-label>Sottocategoria *</mat-label>
        <mat-select name="tipologia" [(ngModel)]="formValues.idTCategoriaBase" placeholder="Sottocategoria competenza di base">
          <mat-option *ngFor="let item of sottocategoriaCompDiBaseConfig" [value]="item.id">
            {{ item.descrizione }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Informazioni sulla competenza</mat-label>
        <textarea rows="3" matInput placeholder="Placeholder 2" name="informazioniCompetenza" [(ngModel)]="formValues.informazioniCompetenza"></textarea>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Livello EQF*</mat-label>
        <input type="number" min="0" matInput placeholder="eqfCompetenza" name="eqfCompetenza" [(ngModel)]="formValues.eqfCompetenza">
      </mat-form-field>

      <div class="referenzazioni-edit">
        <h4 class="sectionTitle">REFERENZIAZIONI
          <mat-icon class="edit_icon" *ngIf="data.competenza.tipologia.id === 1 || data.competenza.tipologia.id === 6" (click)="openClassificazioniDialog(data.competenza)">edit</mat-icon>
        </h4>
      </div>
      <hr class="dividerLine">



      <mat-list role="list" *ngIf="listaAda && listaAda.length>0">
        <mat-list-item role="listitem">
          <strong class="caption">ADA:</strong>
          <span class="grey noFloat" *ngFor="let codice of listaAda">
            <svg height="12" width="12">
              <circle cx="6" cy="7" r="4" stroke="black" stroke-width="1" fill="#008047"/>
            </svg>
            {{ codice.codiceAda }} - {{ codice.descrizione }}
          </span>
        </mat-list-item>
      </mat-list>

      <mat-list role="list" *ngIf="listaIstat && listaIstat.length>0">
        <mat-list-item role="listitem">
          <strong class="caption">Classificazione Nazionale delle Professioni ISTAT:</strong>
          <span class="grey noFloat" *ngFor="let codice of listaIstat">
            <svg height="12" width="12">
              <circle cx="6" cy="7" r="4" stroke="black" stroke-width="1" fill="#008047"/>
            </svg>
            {{ codice.codiceIstat }} - {{ codice.nome }}
          </span>
        </mat-list-item>
      </mat-list>

      <mat-list role="list" *ngIf="listaAteco && listaAteco.length>0">
        <mat-list-item role="listitem">
          <strong class="caption">Classificazione Nazionale delle Attività economiche ATECO:</strong>
          <span class="grey noFloat" *ngFor="let codice of listaAteco">
            <svg height="12" width="12">
              <circle cx="6" cy="7" r="4" stroke="black" stroke-width="1" fill="#008047"/>
            </svg>
            {{ codice.codiceAteco }} - {{ codice.descrizione }}
          </span>
        </mat-list-item>
      </mat-list>

      <mat-list role="list" *ngIf="listaIsco && listaIsco.length>0">
        <mat-list-item role="listitem">
          <strong class="caption">Classificazione Internazionale delle Professioni ISCO:</strong>
          <span class="grey noFloat" *ngFor="let codice of listaIsco">
            <svg height="12" width="12">
              <circle cx="6" cy="7" r="4" stroke="black" stroke-width="1" fill="#008047"/>
            </svg>
            {{ codice.codiceIsco }} - {{ codice.descrizione }}
          </span>
        </mat-list-item>
      </mat-list>

      <h4 class="sectionTitle">ELENCO ABILITA' E CONOSCENZE</h4>
      <hr class="dividerLine">

      <div class="conoscenze-edit">
        <mat-list role="list" *ngIf="listaConoscenze && listaConoscenze.length>0">
          <mat-list-item role="listitem">
            <strong class="caption">Elenco delle Conoscenze
              <mat-icon class="edit_icon" (click)="conoscenzeEvent(data.competenza)">edit</mat-icon>
            </strong>
            <span class="grey noFloat" *ngFor="let codice of listaConoscenze">
              <svg height="12" width="12">
                <circle cx="6" cy="7" r="4" stroke="black" stroke-width="1" fill="#008047"/>
              </svg>
              {{ codice.descrizione }}
            </span>
          </mat-list-item>
        </mat-list>
      </div>

      <div class="abilita-edit">
        <mat-list role="list" *ngIf="listaAbilita && listaAbilita.length>0">
          <mat-list-item role="listitem">
            <strong class="caption">Elenco delle Abilità
              <mat-icon class="edit_icon" (click)="abilitaEvent(data.competenza)">edit</mat-icon>
            </strong>
            <span class="grey noFloat" *ngFor="let codice of listaAbilita">
              <svg height="12" width="12">
                <circle cx="6" cy="7" r="4" stroke="black" stroke-width="1" fill="#008047"/>
              </svg>
              {{ codice.descrizione }}
            </span>
          </mat-list-item>
        </mat-list>
      </div>
    </form>
  </div>
</mat-dialog-content>

<!-- Le azioni sono FUORI dal content per rimanere fisse in basso -->
<div mat-dialog-actions class="actions">
  <button mat-fab extended class="searchbox-buttons save-button" (click)="onNoClick()">
    <mat-icon>close</mat-icon>
    Chiudi
  </button>
  <button mat-fab extended class="searchbox-buttons save-button" type="submit" (click)="salvaCompetenza()">
    <mat-icon>save</mat-icon>
    Salva
  </button>
</div>
